export default function ProcessTimeline() {
  const steps = [
    {
      number: '01',
      title: 'Pre-Qualification',
      description: 'Initial assessment of your current financial position, business structure, and funding goals to determine the best path forward.'
    },
    {
      number: '02',
      title: 'Fundability Audit',
      description: 'Comprehensive review of your credit profile, business compliance, and documentation to identify gaps and opportunities.'
    },
    {
      number: '03',
      title: 'Positioning & Packaging',
      description: 'Strategic preparation of your profile, documentation, and business structure to maximize approval rates and funding amounts.'
    },
    {
      number: '04',
      title: 'Submission Strategy',
      description: 'Targeted application approach using underwriter-level insights to match you with the right funding sources at the right time.'
    },
    {
      number: '05',
      title: 'Funding & Scaling',
      description: 'Post-approval guidance and long-term strategy to maintain and expand your funding capacity as your business grows.'
    }
  ];

  return (
    <section className="py-24 bg-navy text-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-white rounded-full blur-3xl"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <p className="text-xs uppercase tracking-wider text-gray-400 mb-4 font-semibold">
            HOW IT WORKS
          </p>
          <h2 className="text-4xl md:text-5xl font-bold mb-6">
            Your Path to Funding Approval
          </h2>
          <p className="text-lg text-gray-300 max-w-2xl mx-auto">
            A proven five-step process designed to maximize your funding success
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-5 gap-6 relative">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="flex flex-col items-center text-center">
                <div className="w-20 h-20 rounded-full border-3 border-white bg-navy flex items-center justify-center mb-6 relative z-10">
                  <span className="text-2xl font-bold">{step.number}</span>
                </div>
                
                <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6 h-full">
                  <h3 className="text-lg font-semibold mb-3">
                    {step.title}
                  </h3>
                  <p className="text-sm text-gray-300 leading-relaxed">
                    {step.description}
                  </p>
                </div>
              </div>

              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-10 left-1/2 w-full h-0.5 bg-white/30 -z-0"></div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
